import { useEffect, useState } from "react";
import { Coffee, Menu as MenuIcon, X, ShoppingBag } from "lucide-react";
import { NAV_LINKS } from "../data/cafeData";

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-[background-color,box-shadow] duration-300 ${
        scrolled || open
          ? "bg-[#FDFBF7]/95 backdrop-blur-md shadow-[0_1px_0_rgba(61,40,23,0.12)]"
          : "bg-[#FDFBF7]/70 backdrop-blur-md"
      }`}
    >
      <div className="mx-auto flex h-16 md:h-20 max-w-6xl items-center justify-between px-5 md:px-8">
        <a href="#home" data-testid="brand-link" className="flex items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-[#2C1D11] text-[#FDFBF7]">
            <Coffee size={17} strokeWidth={2.2} />
          </span>
          <span className="font-serif text-xl md:text-2xl font-bold tracking-tight text-[#2C1D11]">
            Nomad Cafe
            <span className="ml-1.5 align-middle font-accent text-[10px] font-semibold uppercase tracking-[0.25em] text-[#C86D51]">
              YYC
            </span>
          </span>
        </a>

        <nav className="hidden items-center gap-7 md:flex" data-testid="desktop-nav">
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              data-testid={link.testid}
              className="font-accent text-sm font-medium text-[#4A3B32] transition-colors duration-200 hover:text-[#C86D51]"
            >
              {link.label}
            </a>
          ))}
          <span
            data-testid="header-order-button"
            className="flex cursor-not-allowed items-center gap-2 rounded-full bg-[#D8CFC2] px-5 py-2.5 font-accent text-sm font-semibold text-[#8A7B6E] select-none"
            title="Online ordering is coming soon"
          >
            <ShoppingBag size={15} />
            Order Online · Soon
          </span>
        </nav>

        <button
          data-testid="mobile-menu-toggle"
          aria-label="Toggle menu"
          onClick={() => setOpen(!open)}
          className="flex h-10 w-10 items-center justify-center rounded-full text-[#2C1D11] transition-colors hover:bg-[#F5EFE6] md:hidden"
        >
          {open ? <X size={22} /> : <MenuIcon size={22} />}
        </button>
      </div>

      {open && (
        <nav
          data-testid="mobile-nav"
          className="border-t border-[rgba(61,40,23,0.12)] bg-[#FDFBF7] px-5 pb-6 pt-3 md:hidden"
        >
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              data-testid={`mobile-${link.testid}`}
              onClick={() => setOpen(false)}
              className="block border-b border-[rgba(61,40,23,0.08)] py-3.5 font-accent text-base font-medium text-[#3D2817]"
            >
              {link.label}
            </a>
          ))}
          <span
            data-testid="mobile-order-button"
            className="mt-4 flex cursor-not-allowed items-center justify-center gap-2 rounded-full bg-[#D8CFC2] px-5 py-3 font-accent text-sm font-semibold text-[#8A7B6E] select-none"
          >
            <ShoppingBag size={15} />
            Order Online · Coming Soon
          </span>
        </nav>
      )}
    </header>
  );
};
